import React from "react";
import { Link } from "react-router-dom";
import Expertise1 from '../../images/EXPLORE DIVISIONS/construction-site.jpg';
import Expertise2 from '../../images/EXPLORE DIVISIONS/wp11882668-bmw-neon-wallpapers.jpg';
import Expertise3 from '../../images/EXPLORE DIVISIONS/download (1).jpg';
import Expertise4 from '../../images/EXPLORE DIVISIONS/pv181-1-33-qtaj10566cpof0jd2i16gmvfan38kq7l04tqnxxeuo.webp';
import Expertise5 from '../../images/EXPLORE DIVISIONS/depositphotos_82411686-stock-photo-power-tools-aisle-in-a.jpg';

function ExploreDivisionTwo() {

  return (
    <div className="w-full bg-[#0C2340] text-white py-4">
      <div className="mx-auto md:px-4 grid grid-cols-1 lg:grid-cols-12 gap-3">
        <div className="lg:col-span-4 flex flex-col gap-0 duration-300 ease-in-out">
          <div className="bg-white text-[#0C2340] p-6 rounded-t-lg flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">EXPLORE OUR CUTTING-EDGE PRODUCT SOLUTIONS</h2>
            <p className="text-base md:text-lg leading-relaxed text-justify">Delve into AKT’s Division, where precision meets innovation. Our tools are designed to boost
              efficiency and performance across industries such as automotive, construction, and manufacturing. Explore how AKT’s high-quality
              solutions can enhance your workflow, ensuring that you have the right tools to achieve success in every project and industry application.</p>
          </div>
          <img src={Expertise1} alt="Industry-categories" className="w-full h-full object-cover rounded-b-lg" />
        </div>

        {/* First Div*/}
        <div className="lg:col-span-4 flex flex-col gap-6">
          <div className="flex flex-col bg-[#2e507a] rounded-lg overflow-hidden p-4 duration-300 ease-in-out">
            {/* <img
              src={Expertise2}
              alt='Division-imageaas'
              className="w-full h-[260px] object-cover rounded-md"
            /> */}
            <img
  src={Expertise2}
  alt="Division-imageaas"
  className="w-full h-[260px] object-cover rounded-md transform transition duration-300 hover:scale-110"
/>

            <div className="flex-grow">
              <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                Automotive Division
              </h2>
              <p className="text-base md:text-xl font-bold leading-relaxed ">
                Precision and Performance for the Automotive Industry
              </p>
              <p className="text-base md:text-lg leading-relaxed mt-2">
                Automotive Division delivers high
                performance components and advanced
                solutions tailored to the automotive industry.
                Our products include OEM parts, coatings,
                adhesives, and more, all designed for
                precision and reliability. Whether enhancing
                vehicle safety, efficiency, or longevity, Our
                automotive solutions meet the demanding
                standards of the industry. Trust AKT to keep
                your automotive performance ahead of the
                curve.
              </p>
            </div>
            <Link to="/">
              <button
                className="px-3 py-3 w-full mt-9 border-2 border-[#0C2340] bg-white hover:!bg-[#0c2340] text-[#0C2340] hover:text-white font-semibold md:text-[25px] rounded-lg transition duration-300"
              >
                Explore Our Solutions
              </button>

            </Link>

          </div>


          {/* ..............Second Div............ */}
          <div className="flex flex-col bg-[#2e507a] rounded-lg overflow-hidden p-4 duration-300 ease-in-out md:max-h-[845px] md:min-h-[845px]">
            {/* <img
              src={Expertise3}
              alt='Division-images'
              className="w-full h-[260px] object-cover rounded-md"
            /> */}
             <img
  src={Expertise3}
  alt="Division-images"
  className="w-full h-[260px] object-cover rounded-md transform transition duration-300 hover:scale-110"
/>
            <div className="flex-grow">
              <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                Trading Division
              </h2>
              <p className="text-base md:text-xl font-bold leading-relaxed ">
                Innovative Products for Glazing, Coatings,
                Adhesives, and Industrial Sales
              </p>
              <p className="text-base md:text-lg leading-relaxed mt-2">
                Trading Division specializes in premium-
                quality products like glazing, coatings,
                adhesives, and industrial sales materials. Our
                solutions are designed to enhance
                performance, efficiency, and protection
                across various industries. Whether in
                construction, automotive, or electronics,
                AKT offers tailored solutions that meet your
                business's unique requirements. Let our
                products help you achieve lasting results and
                maintain industry-leading standards.
              </p>
            </div>
            <Link to="/">
              <button
                className="px-3 py-3 w-full mt-9 border-2 border-[#0C2340] bg-white hover:!bg-[#0c2340] text-[#0C2340] hover:text-white font-semibold md:text-[25px] rounded-lg transition duration-300"
              >
                Explore Our Solutions
              </button>

            </Link>
          </div>
        </div>

        {/* Third Div: */}



        <div className="lg:col-span-4 flex flex-col gap-6">
          <div className="flex flex-col bg-[#2e507a] rounded-lg overflow-hidden p-4 duration-300 ease-in-out">
            {/* <img
              src={Expertise4}
              alt='Division-imagess'
              className="w-full h-[260px] object-cover rounded-md"
            /> */}
             <img
  src={Expertise4}
  alt="Division-imagess"
  className="w-full h-[260px] object-cover rounded-md transform transition duration-300 hover:scale-110"
/>
            <div className="flex-grow">
              <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                Steel Division
              </h2>
              <p className="text-base md:text-xl font-bold leading-relaxed">
                Building the Future with Strength and Durability
              </p>
              <p className="text-base md:text-lg leading-relaxed mt-2">
                Steel Division provides top-tier steel
                solutions that cater to construction,
                manufacturing, and heavy industries. Our
                high-strength, corrosion-resistant steel
                products ensure durability in the most
                challenging environments. With custom
                fabrication and structural steel offerings,
                AKT offers reliable, cost-effective solutions.
                Whether building the future or maintaining
                existing structures, AKT’s steel products
                provide the strength needed to endure.
              </p>
            </div>
            <Link to="/">
              <button
                className="px-3 py-3 w-full mt-9 border-2 border-[#0C2340] bg-white hover:!bg-[#0c2340] text-[#0C2340] hover:text-white font-semibold md:text-[25px] rounded-lg transition duration-300"
              >
                Explore Our Solutions
              </button>

            </Link>
          </div>


          {/* ..............Forth Div............ */}
          <div className="flex flex-col bg-[#2e507a] rounded-lg overflow-hidden p-4 duration-300 ease-in-out md:max-h-[845px] md:min-h-[845px]">
            {/* <img
              src={Expertise5}
              alt='Division-imageas'
              className="w-full h-[260px] object-cover rounded-md"
            /> */}
             <img
  src={Expertise5}
  alt="Division-imageas"
  className="w-full h-[260px] object-cover rounded-md transform transition duration-300 hover:scale-110"
/>
            <div className="flex-grow">
              <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                Tools Division
              </h2>
              <p className="text-base md:text-xl font-bold leading-relaxed ">
                Innovative Tools for Every Trade - Coming Soon and Industrial Sales
              </p>
              <p className="text-base md:text-lg leading-relaxed mt-2">
                Tool Division is dedicated to providing high-
                quality, precision tools for a wide range of
                industries. From construction to automotive
                and manufacturing, our tools are designed to
                enhance efficiency, accuracy, and
                performance. Crafted for durability, our tools
                are built to withstand tough conditions,
                offering reliable solutions that help
                businesses achieve excellence in every
                project. Stay tuned for more
              </p>
            </div>
            <Link to="/">
              <button
                className="px-3 py-3 w-full mt-9 border-2 border-[#0C2340] bg-white hover:!bg-[#0c2340] text-[#0C2340] hover:text-white font-semibold md:text-[25px] rounded-lg transition duration-300"
              >
                Explore Our Solutions
              </button>

            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExploreDivisionTwo;
